import React from 'react'
import reportStyles from './PDFReportStyles';    
import { Text, Page, View, Image} from '@react-pdf/renderer'

const VaccinationPage = (params) => {
   
  const entity = params.entity;
  const reportParams = params.params;  

  return (

<Page size="A4" style={reportStyles.page}>
    <View style={reportStyles.HeaderContainer}>
        <Image src={process.env.PUBLIC_URL + '/images/VaccineHeader1.jpg'}  style={reportStyles.headerImage}/>                                                 
        <Text style={reportStyles.PageTitle}>Vaccination Overview - Part 1</Text>                    
    </View>                            
    <View style={reportStyles.CenterContainerStart}>    
        <View style={reportStyles.table}>
            <View style={reportStyles.rowPageSubHeader}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageSubTitle}>Vaccines</Text>
                </View>
                <View style={reportStyles.cell60NB}>
                    <Text style={reportStyles.PageSubTitle}>Recommended Doses</Text>
                </View>
            </View>                               
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>BCG</Text>
                    <Text style={reportStyles.descriptionSmall}>Given at birth</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>Oral, Injectable PV</Text>
                    <Text style={reportStyles.descriptionSmall}>OPV at Birth, P.Sundays 5 Y, IPV
                            6,10,14 wks and 16 -18 M, 4-6 Y</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtnSQ.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtnSQ.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtnSQ.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtnSQ.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/OrangeRadioBtnSQ.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>Hepatitis B (HBV)</Text>
                    <Text style={reportStyles.descriptionSmall}>At Birth, and at 6, 10 and 14 weeks</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>DPT</Text>
                    <Text style={reportStyles.descriptionSmall}>Diphtheria, Tetanus,Pertusis. Given at
                    6,10,14 W; at 16-18M and 4 -6 Y</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/OrangeRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>HiB</Text>
                    <Text style={reportStyles.descriptionSmall}>H Influenza B. Given at 6,10,14 W and 16-18M</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>Rotavirus</Text>
                    <Text style={reportStyles.descriptionSmall}>For Rota Virus Diarrhoea, given at 6,10,14 W</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>PCV</Text>
                    <Text style={reportStyles.descriptionSmall}>Pneumococcal, Given at 6,10,14 W and at 15 M</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageTextSmall}>MMR</Text>
                    <Text style={reportStyles.descriptionSmall}>Measles, Mumps, Rubella V, Given at 9,15 M and 4-6 Y</Text>
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
                <View style={reportStyles.cell10}>
                    <Image src={process.env.PUBLIC_URL + '/images/GreenRadioBtn.png'} style={reportStyles.image40x40Cell}/> 
                </View>
            </View>
        </View>                                   
    </View>                            
    <View style={reportStyles.FooterContainerSmall}>
        <Text style={reportStyles.footer}>*Each Dot or Square Indicates a scheduled vaccine dose. A grey dot indicates there is still time for
the vaccine to be taken. A Red indicates a missed dose and orange indicates a potential missed
dose. We recommend a paediatrician consultation in case you see any red or orange dots on your
child's report.

# Please note that these recommendations are based on the schedule published by the Indian
Pediatrics Association.
        </Text>
    </View>                            
    </Page>  



  )          
}
  
export default VaccinationPage